const PaymentTransactionTypeEnum = Object.freeze({
    PURCHASED: "Purchased",
    CANCELLED: "Refunded",
    TOPPED_UP: "Top up"
});

export default PaymentTransactionTypeEnum;
